<template>
    <div class="case-detail">
        <div class="detail-container">
            <div class="detail-header">
                <h1 class="case-title">{{ caseData.title }}</h1>
                <p class="case-time">{{ caseData.time }}</p>
            </div>

            <div class="detail-content">
                <div class="image-gallery">
                    <img v-for="(img, index) in caseData.images" :key="index" :src="img" :alt="'案例图片 ' + (index + 1)"
                        class="gallery-image">
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'CaseDetail',
    components: {

    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            caseData: {
                title: '',
                images: []
            }
        }
    },
    mounted() {
        this.loadCaseDetail()
    },
    methods: {
        loadCaseDetail() {
            const caseDetails = {
                '1': {
                    title: '间谍过家家杭州湖滨快闪店',
                    images: [
                        'https://cdn.magicmart.vip/website/assets/case/Aniya/2.png',
                        'https://cdn.magicmart.vip/website/assets/case/Aniya/4.png'
                    ],
                    time: '2025年7月19日'
                },
                '3': {
                    title: '上海静安大悦城 咒术回战',
                    images: [
                        'https://cdn.magicmart.vip/website/assets/case/Jujutsu/1.png',
                        'https://cdn.magicmart.vip/website/assets/case/Jujutsu/2.png',
                        'https://cdn.magicmart.vip/website/assets/case/Jujutsu/3.png',
                        'https://cdn.magicmart.vip/website/assets/case/Jujutsu/4.png',
                        'https://cdn.magicmart.vip/website/assets/case/Jujutsu/5.png'
                    ],
                    time: '2025年7月10日'
                },
                '2': {
                    title: '魔道祖师动画七周年杭州站',
                    images: [
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/1.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/2.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/3.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/4.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/5.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/6.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/7.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/8.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/9.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/10.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/11.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/12.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/13.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/14.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/15.png',
                        'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/16.png'
                    ],
                    time: '2025年6月20日'
                },
                '4': {
                    title: '漫屋实体店现场场景照',
                    images: [
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/1.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/2.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/3.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/4.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/5.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/6.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/7.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/8.png',
                        'https://cdn.magicmart.vip/website/assets/case/physicalStore/9.png'
                    ],
                    time: ''
                },
                '5': {
                    title: '魔道祖师动画七周年上海站',
                    images: [
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/1.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/2.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/3.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/4.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/5.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/6.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/7.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/8.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/9.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/10.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/11.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/12.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/13.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/14.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/15.png',
                        'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/16.png'
                    ],
                    time: '2025年10月01日'
                },
                '6': {
                    title: '魔道祖师动画七周年成都站',
                    images: [
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/1.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/2.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/3.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/4.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/5.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/6.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/7.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/8.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/9.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/10.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/11.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/12.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/13.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/14.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/15.png',
                        'https://cdn.magicmart.vip/website/assets/case/tianfumodao/16.png'
                    ],
                    time: '2025年9月29日'
                }
            }

            this.caseData = caseDetails[this.id] || caseDetails['1']
        }
    }
}
</script>

<style scoped>
.case-detail {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f5f5f5;
    padding-bottom: 60px;
}

.detail-container {
    flex: 1;
    max-width: 1200px;
    margin: 0 auto;
}

.detail-header {
    text-align: center;
    margin-top: 162px;
    margin-bottom: 80px;
}

.case-title {
    font-weight: 600;
    font-size: 48px;
    color: #1B1B1B;
    margin-bottom: 16px;
}

.case-time {
    font-weight: 600;
    font-size: 30px;
    color: #1B1B1B;
}

.case-subtitle {
    font-size: 20px;
    color: #666;
    font-weight: 500;
}

.detail-content {}

.image-gallery {
    display: grid;
    grid-template-columns: repeat(3, 491px);
    gap: 28px;
    justify-content: center;
}

.gallery-image {
    width: 491px;
    height: 275px;
    object-fit: cover;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}
</style>
